import React from 'react';
import { PropTypes } from 'prop-types';
// state
import { useSelector } from 'react-redux';
import { selectors as uiSelectors } from 'state/ui';
import { selectors as salesIntelligenceSelectors } from 'state/salesIntelligence';
// styles
import styled from 'styled-components';
// components
import PaymentDataModal from 'components/orders/PaymentDataModal';
import ModalCancelOrder from 'components/ModalCancelOrder';
import RecurringOrderSuggestionsModal from 'components/RecurringOrderSuggestionsModal';
import RecurringOrderSuggestionsDiscardReasonsModal from 'components/RecurringOrderSuggestionsDiscardReasonsModal';

const OrdersModals = ({ className }) => {
  const isPaymentDataPendingModalOpened = useSelector(
    uiSelectors.isPaymentDataPendingModalOpened
  );
  const isPaymentDataDeniedModalOpened = useSelector(
    uiSelectors.isPaymentDataDeniedModalOpened
  );
  const isModalCancelOrderOpened = useSelector(
    uiSelectors.isCancelOrderModalOpened
  );
  const isRecurringOrderSuggestionsModalOpened = useSelector(
    salesIntelligenceSelectors.isRecurringOrderSuggestionsModalOpened
  );
  const isRecurringOrderSuggestionsDiscardReasonsModalOpened = useSelector(
    salesIntelligenceSelectors.isRecurringOrderSuggestionsDiscardReasonsModalOpened
  );

  return (
    <>
      {isPaymentDataPendingModalOpened && <PaymentDataModal type="pending" />}
      {isPaymentDataDeniedModalOpened && <PaymentDataModal type="denied" />}
      {isModalCancelOrderOpened && <ModalCancelOrder />}
      {isRecurringOrderSuggestionsModalOpened && (
        <RecurringOrderSuggestionsModal />
      )}
      {isRecurringOrderSuggestionsDiscardReasonsModalOpened && (
        <RecurringOrderSuggestionsDiscardReasonsModal />
      )}
    </>
  );
};

OrdersModals.propTypes = {
  className: PropTypes.string,
};

export default styled(OrdersModals)``;
